import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import StationAdoptIcon from "../stationadopt/StationAdoptIcon";
import {useTheme} from '@material-ui/core/styles';
import DashWidget from "./DashWidget";
import StationDataStore, {getStationDataByStationId} from "../stores/StationDataStore";
import moment from 'moment';
import SimpleList from "../../framework/util/uicomps/lists/SimpleList";
import PressJobsIcon from "../pressjobs/PressJobsIcon";
import {getAllRecentJobs} from "../stores/PressJobsStore";

const useStyles = makeStyles((theme) => ({
    root: {
        // maxWidth: 345,
    },
    refreshFab: {
        align: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    media: {
        // height: 140,
    },
}));


export default function RecentlyPrintedEntireCompany(props) {

    const theme = useTheme();
    const classes = useStyles();

    const hours = 24;
    const limit = 10;
    const refreshSeconds = 5 * 60;
    const [jobs, setJobs] = React.useState();
    const refresh = async () => {
        const recentJobs = await  getAllRecentJobs(hours, limit);
        if (recentJobs) {
            setJobs(recentJobs.data);
        }
    }

    const formatPrimary = (job) => {
        return job.name;
    }

    const formatSecondary = (job) => {
        const ts = moment(job.printingEnd).fromNow();//.format(formatstr);
        const spreads = job.spreads;
        const site = job["facility"]
        const station = job["device"]

        return ts + ', Site: ' + site + ', Station: ' + station + '';
    }

    const title = 'All Sites And Stations';
    const subtitle = 'Recently Printed Jobs (last ' + hours + ' hours, limit ' + limit + ')';

    const pressJobs = jobs ? jobs : [];
    pressJobs.forEach((job)=>job.key = job.name);
    const pressJobsList = ( <div>
        <SimpleList rows={pressJobs}
                    getPrimaryFunc={formatPrimary} getSecondaryFunc={formatSecondary}/>
    </div>);

    const icon = (<StationAdoptIcon/>);
    const actions =null;//[(<RefreshButton />)];
    return (
        <DashWidget title={title}  subtitle={subtitle} Icon={<PressJobsIcon/>} actions={actions} details={pressJobsList} showRefresh={true} onRefreshFunc={refresh} refreshSeconds={5 * 60}/>
    );
}
